import type { ProfileTab } from '../../hooks/useProfile';

/** Ordre canonique des onglets (miroir de PROFILE_TABS du PoC). */
export const PROFILE_TABS: readonly ProfileTab[] = [
  'apercu', 'pouls', 'objectifs', 'documents', 'remuneration', 'gestion',
] as const;

/**
 * M-802 : `raw` absent/invalide/non autorise -> « apercu », silencieusement.
 * Fonction PURE (testee) — la garde reelle reste serveur.
 */
export function resolveProfileTab(raw: string | null | undefined, available: ProfileTab[]): ProfileTab {
  return available.find((t) => t === raw) ?? 'apercu';
}
